module.exports = __webpack_public_path__ + "media/images/banner-assets/zh-tw/banner3-6bcbd826682866b0a9d45bcc0312df5a.jpg";